var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.stats)?_c('vue-apex-charts',{key:_vm.key,attrs:{"type":"bar","options":_vm.options,"series":_vm.series,"height":_vm.typeData === 'M' ? '350px' : '350px'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }